export const serviceType = (text) => {
    if (text === 'внесение записи в договор' || text === 'единоразово' || text === 'за штуку') {
        return 'one_time';
    }
    if (text === 'за сутки') {
        return 'day';
    }
    return false;
}